/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Marin PUT /sections/:id — edit course ({@link COURSE_EDIT_REQUESTED}).
 *
 * @file EditCourseService.js
 */

import Framework, { BaseService } from '@greenville/framework';
import {
  COURSE_EDIT_REQUESTED,
  COURSE_EDIT_COMPLETED,
  COURSE_EDIT_FAILED
} from '../../../common/constants';

export default class EditCourseService extends BaseService {
  constructor() {
    super(COURSE_EDIT_REQUESTED, 'editCourseStatus');
  }

  /** PUT /sections/:id */
  handleEvent(eventName, eventData = {}) {
    const { sectionId, payload } = eventData;
    const id = String(sectionId || payload?.id || '').trim();

    if (!id) {
      return Promise.reject(new Error('EditCourseService: sectionId is required'));
    }

    return this.getClient('marin').put(`/sections/${id}`, payload);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response, eventData = {}) {
    const { data } = response;
    const { sectionId, callback } = eventData;
    const body = {
      ...data,
      courseId: data?.courseId ?? data?.id ?? sectionId
    };

    Framework.getEventManager().publish(COURSE_EDIT_COMPLETED, body);

    if (typeof callback === 'function') {
      callback(body);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(COURSE_EDIT_FAILED, error);
  }
}
